<template>
    <div class="footer-comp mt-auto">
        <p class="text-center mt-2 p-1">
            &copy; Copyright 2021 by Valuation BR.
        </p>
    </div>
</template>

<script>
export default {
  name: 'FooterComp',
};
</script>

<style scoped>
</style>
